import classnames from 'classnames'
import React from 'react'
import KeyboardArrowDownIcon from '@material-symbols/svg-300/rounded/keyboard_arrow_down.svg'

import styles from './ExpandedIncidator.module.scss'

export default React.memo(function ExpandedIncidator({ horizontal }: { horizontal?: boolean }) {
  return <KeyboardArrowDownIcon className={classnames(styles.ExpandedIncidator, { [styles.horizontal]: horizontal })} />
})
